import { readCurrentTreatments } from './currentTreatments';

export function exactLegacyTreatmentText(form) {
  return [...new Set([
    typeof form?.traitements === 'string' ? form.traitements.trim() : '',
    typeof form?.medicaments === 'string' ? form.medicaments.trim() : '',
  ].filter(Boolean))].join('\n');
}

/**
 * Matérialise uniquement le choix qu'Anissa vient de poser. Le texte legacy
 * reste intact dans sa clé historique : il est recopié dans le structuré
 * seulement après un « oui » explicite, jamais à l'ouverture de la fiche.
 */
export function reconcileExplicitTreatmentChoice(form, status) {
  if (status !== 'oui' && status !== 'non') {
    return Object.freeze({ traitementsActuels: status });
  }
  if (status === 'non') {
    return Object.freeze({
      traitementsActuels: 'non',
      traitementsDetail: '',
      traitementsMomentPrise: '',
    });
  }
  const structured = typeof form?.traitementsDetail === 'string'
    ? form.traitementsDetail
    : '';
  return Object.freeze({
    traitementsActuels: 'oui',
    traitementsDetail: structured.trim() ? structured : exactLegacyTreatmentText(form),
    traitementsMomentPrise: typeof form?.traitementsMomentPrise === 'string'
      ? form.traitementsMomentPrise
      : '',
  });
}

function assertComplementsActuels(form) {
  const complements = form?.complementsActuels;
  // Champ laissé vide = aucun complément. Le clic de relecture ne doit pas
  // exiger d'écrire « Aucun » pour dire ce que le vide dit déjà.
  if (complements === undefined || complements === null) return;
  if (!Array.isArray(complements)) {
    throw new Error('À valider Anissa — confirme les compléments alimentaires actuellement pris dans « Santé et suivi médical ».');
  }
  if (complements.length === 0) return;
  const invalid = complements.some((item) => (
    !item
    || typeof item !== 'object'
    || Array.isArray(item)
    || Object.keys(item).some((key) => key !== 'nom' && key !== 'dose')
    || typeof item.nom !== 'string'
    || !item.nom.trim()
    || (Object.hasOwn(item, 'dose') && typeof item.dose !== 'string')
  ));
  const aucun = complements.filter((item) => String(item?.nom || '').trim().toLowerCase() === 'aucun');
  if (invalid || (aucun.length > 0 && (
    complements.length !== 1
    || String(aucun[0]?.dose || '').trim()
  ))) {
    throw new Error('À valider Anissa — relis la liste des compléments alimentaires actuellement pris.');
  }
}

export function invalidateAnamnesisReview(form, changes = {}) {
  return {
    ...(form || {}),
    ...changes,
    profilsRisqueVerifiesParAnissa: false,
    traitementsVerifiesParAnissa: '',
    traitementsVerifiesLe: '',
  };
}

/**
 * Le clic final d'Anissa confirme la relecture des informations visibles.
 * Les éventuels flags à risque restent intacts : cette preuve de relecture
 * ne lève donc aucun blocage ni aucune validation obligatoire du plan.
 */
export function sealAnamnesisReview(form, reviewedOn = new Date().toISOString().slice(0, 10)) {
  const treatments = readCurrentTreatments(form);
  if (treatments.status !== 'oui' && treatments.status !== 'non') {
    throw new Error('À valider Anissa — confirme si un traitement ou médicament est actuellement pris.');
  }
  if (treatments.status === 'oui' && !treatments.text) {
    throw new Error('À valider Anissa — renseigne le détail des traitements ou médicaments en cours.');
  }
  assertComplementsActuels(form);
  const reconciledTreatments = reconcileExplicitTreatmentChoice(form, treatments.status);
  // L'ouverture aux compléments est une préférence, pas une donnée de sécurité :
  // elle est signalée comme « à confirmer » ailleurs, elle ne doit pas refuser
  // le clic de relecture d'Anissa au milieu d'une consultation.
  return {
    ...(form || {}),
    ...reconciledTreatments,
    flagsProfilRisque: Array.isArray(form?.flagsProfilRisque) ? [...form.flagsProfilRisque] : [],
    profilsRisqueVerifiesParAnissa: true,
    traitementsVerifiesParAnissa: 'oui',
    traitementsVerifiesLe: reviewedOn,
  };
}
